import { Typography } from "@mui/material";
import { useCurrencyRates } from "../../hooks/useCurrencyRates";
import { useFeatureFlag } from "../../hooks/useFeatureFlags";
import { useHomeCurrency } from "../../hooks/useHomeCurrency";
import {
  formatConvertedPrice,
  formatConvertedTotals,
} from "../../utility/utilityFunctions";

// "≈ ₦67,400" under a price listed in another currency. Display only: the buyer
// pays in the listed currency, so never use this on orders, negotiation,
// payment or refund screens, where it could be mistaken for what was agreed.
// Pass amounts the viewer can already see (see getProductPriceBounds), or totals
// from sumByCurrency, and showExplainer where there's room to say it's an
// estimate (needs a single currency to name).
const ConvertedPrice = ({
  amount,
  maxAmount,
  currency,
  totals,
  showExplainer = false,
  variant = "caption",
  sx,
}) => {
  const enabled = useFeatureFlag("price-conversion-display");
  const homeCurrency = useHomeCurrency();
  const rates = useCurrencyRates({ enabled });

  if (!enabled) return null;
  const label = totals
    ? formatConvertedTotals({ totals, to: homeCurrency, rates })
    : formatConvertedPrice({
        amount,
        maxAmount,
        from: currency,
        to: homeCurrency,
        rates,
      });
  if (!label) return null;

  return (
    <>
      <Typography
        variant={variant}
        color="text.secondary"
        sx={{ display: "block", ...sx }}
      >
        {label}
      </Typography>
      {showExplainer && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mb: 1.5 }}
        >
          Estimate only. You pay in {currency}. Your bank's rate may differ.
        </Typography>
      )}
    </>
  );
};

export default ConvertedPrice;
